import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InteractionsRoutingModule } from './interactions-routing.module';
import { AddInteractionComponent } from './add-interaction/add-interaction.component';
import { AllInteractionsComponent } from './all-interactions/all-interactions.component';
import { EditInteractionComponent } from './edit-interaction/edit-interaction.component';
import { CustomIconsModule } from 'src/app/theme/shared/components/custom-icons/custom-icons.module';
import {InteractionListItemModule} from '../../components/interactions/interaction-list-item/interaction-list-item.module';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import {QuizComponent} from '../../components/interactions/forms/quiz/quiz.component';
import { ArchwizardModule } from 'angular-archwizard';
import { ReactiveFormsModule } from '@angular/forms';
import { MediaManagerModule } from 'src/app/components/media-manager/media-manager.module';
import { LeftRightComponent } from 'src/app/components/interactions/forms/left-right/left-right.component';
import { MemoryComponent } from 'src/app/components/interactions/forms/memory/memory.component';
import { QuadratoMagicoComponent } from 'src/app/components/interactions/forms/quadrato-magico/quadrato-magico.component';
import { IndovinaParolaComponent } from 'src/app/components/interactions/forms/indovina-parola/indovina-parola.component';
import { StaticaComponent } from 'src/app/components/interactions/forms/statica/statica.component';
import { VideoComponent } from 'src/app/components/interactions/forms/video/video.component';
import { AudioComponent } from 'src/app/components/interactions/forms/audio/audio.component';
import { TinymceModule } from 'angular2-tinymce';


@NgModule({
  declarations: [
    AddInteractionComponent,
    AllInteractionsComponent,
    EditInteractionComponent,
    QuizComponent,
    LeftRightComponent,
    MemoryComponent,
    QuadratoMagicoComponent,
    IndovinaParolaComponent,
    StaticaComponent,
    VideoComponent,
    AudioComponent
  ],
  imports: [
    CommonModule,
    InteractionsRoutingModule,
    CustomIconsModule,
    InteractionListItemModule,
    SharedModule,
    ArchwizardModule,
    ReactiveFormsModule,
    MediaManagerModule,
    TinymceModule.withConfig({
      remove_trailing_brs: true,
      remove_linebreaks: true,
      indent: false,
      branding: false,
      auto_focus: false,
      plugins: 'link table',
      contextmenu: 'link table'
    }),
  ]
})
export class InteractionsModule { }
